module.exports = __webpack_public_path__ + "static/media/p30.6646265c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/priceless/p30.jpg
// module id = 379
// module chunks = 0